import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/AuthProvider";
import "./navbar.css";
import axios from "axios";
import logo from "./../assest/logo-my-color-event.png";

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);

  const [cart, setCart] = useState([]);
  const location = useLocation();

  useEffect(() => {
    // Set initial cart state from localStorage
    const savedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(savedCart);

    // Listen for changes across tabs/windows
    const handleStorageChange = (event) => {
      if (event.key === "cart") {
        const updatedCart = JSON.parse(event.newValue) || [];
        setCart(updatedCart);
      }
    };
    window.addEventListener("storage", handleStorageChange);

    // Timer to update cart every second
    const intervalId = setInterval(() => {
      const updatedCart = JSON.parse(localStorage.getItem("cart")) || [];
      setCart(updatedCart);
    }, 1000);

    // Cleanup both interval and event listener on unmount
    return () => {
      clearInterval(intervalId);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  const isActive = (path) => location.pathname === path;

  const [eventData, setEventData] = useState([]);

  useEffect(() => {
    const fetcheventData = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/eventCollection"
        );
        setEventData(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    // Fetch data immediately and then set interval
    fetcheventData();
    const intervalId = setInterval(fetcheventData, 1000); // Fetch every 2 seconds

    // Clear the interval when component unmounts
    return () => clearInterval(intervalId);
  }, []);

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get("https://server-gs.vercel.app/category");
        setCategories(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    // Fetch data immediately and then set interval
    fetchCategories();
    const intervalId = setInterval(fetchCategories, 1000); // Fetch every 2 seconds

    // Clear the interval when component unmounts
    return () => clearInterval(intervalId);
  }, []);

  const [isDropdownVisible, setDropdownVisible] = useState(false);

  const toggleDropdown = (visible) => {
    setDropdownVisible(visible);
  };

  const [isDropdownVisibleRental, setDropdownVisibleRental] = useState(false);

  const toggleDropdownRental = (visible) => {
    setDropdownVisibleRental(visible);
  };

  return (
    <div className="w-full fixed top-0 z-50 px-4 py-4 pointer-events-none">
  <nav className="max-w-screen-2xl mx-auto pointer-events-auto">
    <div className="bg-[#030014]/70 backdrop-blur-xl border border-white/10 rounded-2xl px-6 py-3 flex items-center justify-between shadow-[0_8px_32px_0_rgba(0,0,0,0.37)]">
      
      {/* Brand Logo */}
      <Link
        to="/"
        className="flex items-center space-x-2 group transition-all"
      >
        <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-500/20 group-hover:scale-110 transition-transform">
          <span className="text-white font-black text-xl">M</span>
        </div>
        <div className="flex flex-col">
          <span className="text-lg font-black tracking-tighter text-white uppercase leading-none">
            MY COLOR <span className="text-blue-500">EVENTS</span>
          </span>
          <span className="text-[10px] text-gray-400 font-bold tracking-[0.2em] uppercase leading-none mt-1">
            Design Studio
          </span>
        </div>
      </Link>

      {/* Auth Actions */}
      <div className="flex items-center gap-3 lg:order-2">
        {user ? (
          <>
            <Link
              to="/dashboard"
              className="px-5 py-2 text-xs font-black tracking-widest text-white bg-blue-600 rounded-xl hover:bg-blue-500 hover:shadow-[0_0_20px_rgba(37,99,235,0.4)] transition-all active:scale-95 uppercase"
            >
              Dashboard
            </Link>
            <button
              onClick={logout}
              className="px-5 py-2 text-xs font-black tracking-widest text-gray-400 border border-white/10 rounded-xl hover:bg-white/5 hover:text-white transition-all uppercase"
            >
              Logout
            </button>
          </>
        ) : (
          <>
            <Link
              to="login"
              className="px-5 py-2 text-xs font-black tracking-widest text-gray-300 hover:text-white transition-colors uppercase"
            >
              Log In
            </Link>
            <Link
              to="signUp"
              className="px-6 py-2.5 text-xs font-black tracking-widest text-white bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl shadow-lg shadow-blue-500/20 hover:shadow-blue-500/40 hover:-translate-y-0.5 transition-all active:scale-95 uppercase"
            >
              Get Started
            </Link>
          </>
        )}
      </div>
    </div>
  </nav>
</div>
  );
};

export default Navbar;
